exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image[data-v-28cedc73] {\r\n  max-width: 400px;\r\n  max-height: 400px;\n}\n.text-with-linebreak[data-v-28cedc73] {\r\n  white-space: pre-line;\n}\r\n", ""]);

// exports
